import { commonListReducers } from "../reducer";

export function commonPlainListReducerFactory(rootProp, initialState) {
    return function commonDatalistReducer(state = initialState, action) {
        state = commonListReducers(state, action, initialState, rootProp);
        return state;
    };
};
